import { StaticImage } from "gatsby-plugin-image"

import { Heading } from "@trueskin-web/components"

const PageHeader = () => (
  <div
    sx={{
      my: 5,
      display: "flex",
      columnGap: 2,
      alignItems: "flex-start",
      justifyContent: "space-between",
    }}
  >
    <div sx={{ flex: 3 }}>
      <Heading sx={{ mb: 1, fontWeight: "bold", lineHeight: "body" }}>
        Danke! <br />
        So geht’s weiter:
      </Heading>
    </div>
    <StaticImage
      src="./images/dr_sarah_2x.png"
      alt=""
      width={64}
      height={64}
      sx={{ flexShrink: 0 }}
    />
  </div>
)

export default PageHeader
